import livechat from '@/utils/axios/livechat'
import qs from 'query-string'
import {
    RoomJourney,
    OverviewComparison,
    SourceAttributionResponse,
    UserFlow,
    AnalyticsQuery,
} from '../types/analytics'

// Get room journey (page visits timeline)
export const getRoomJourney = async (roomId: string): Promise<RoomJourney> => {
    const response = await livechat.get<RoomJourney>(
        `/chat/analytics/journey/${roomId}`
    )
    return response.data
}

// Get analytics overview stats
export const getAnalyticsOverview = async (
    query?: AnalyticsQuery
): Promise<OverviewComparison> => {
    const params = qs.stringify(
        {
            from: query?.from,
            to: query?.to,
            compare: query?.compare,
        },
        { skipEmptyString: true, skipNull: true }
    )
    const response = await livechat.get<OverviewComparison>(
        `/chat/analytics/overview${params ? `?${params}` : ''}`
    )
    return response.data
}

// Get source attribution report
export const getSourceAttribution = async (
    query?: AnalyticsQuery
): Promise<SourceAttributionResponse> => {
    const params = qs.stringify(
        {
            from: query?.from,
            to: query?.to,
        },
        { skipEmptyString: true, skipNull: true }
    )
    const response = await livechat.get<SourceAttributionResponse>(
        `/chat/analytics/sources${params ? `?${params}` : ''}`
    )
    return response.data
}

// Get user flow data for Sankey diagram
export const getUserFlow = async (
    query?: AnalyticsQuery
): Promise<UserFlow> => {
    const params = qs.stringify(
        {
            from: query?.from,
            to: query?.to,
        },
        { skipEmptyString: true, skipNull: true }
    )
    const response = await livechat.get<UserFlow>(
        `/chat/analytics/flow${params ? `?${params}` : ''}`
    )
    return response.data
}
